import CancelCompletePageView from 'src/pages/CancelPage/CancelCompletePage/view'
import usePageNav from 'src/hooks/usePageNav.hook'

import { Bridge } from 'src/utils/bridge'
import { useEffect } from 'react'
import useCustomCookies from 'src/hooks/useCustomCookies.hook'
export interface CancelCompleteProps {
  introPageNav: () => void
  appExit: () => void
}

const CancelCompletePage = () => {
  const { introPageNav } = usePageNav()
  const { removeAllCookies } = useCustomCookies()

  const appExit = () => {
    window.location.replace(window.location.origin)
    Bridge.handleReqAppClose()
  }

  useEffect(() => {
    removeAllCookies()
  }, [])

  const props: CancelCompleteProps = {
    appExit,
    introPageNav,
  }

  return <CancelCompletePageView {...props} />
}
export default CancelCompletePage
